import React from 'react';
import { ArrowUpRight } from 'lucide-react';

interface ShareSidebarProps {
  articleUrl: string;
  onCopyResult?: (success: boolean) => void;
}

export function ShareSidebar({ articleUrl, onCopyResult }: ShareSidebarProps) {
  function handleCopyLink() {
    navigator.clipboard.writeText(articleUrl).then(
      () => onCopyResult?.(true),
      () => onCopyResult?.(false),
    );
  }

  return (
    <aside className="flex w-article-sidebar shrink-0 flex-col items-end gap-6">
      <p className="text-caption-lg text-text-tertiary">
        Share
      </p>

      <button
        type="button"
        onClick={handleCopyLink}
        className="site-btn-secondary site-btn-md whitespace-nowrap"
      >
        Copy link
        <ArrowUpRight size={14} />
      </button>
    </aside>
  );
}
